import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DevToolSection, devCheckLabel, devCheckRow, devFieldStack, devHint, devLabel } from '/imports/ui/DevToolSection';
import { Input } from '/imports/ui/Input';
import { runIngestImages } from '/imports/api/devtools';

export const DevToolIngestImages = () => {
  const [setCodes, setSetCodes] = useState('');
  const [force, setForce] = useState(false);
  const [cc, setCc] = useState(true);
  const [sc, setSc] = useState(true);
  const [ca, setCa] = useState(true);
  const [sa, setSa] = useState(true);
  const [setIcons, setSetIcons] = useState(true);
  const [thumbs, setThumbs] = useState(true);
  const [loading, setLoading] = useState(false);
  const [lastJobId, setLastJobId] = useState('');

  const run = async () => {
    setLoading(true);
    try {
      const res = await runIngestImages.call({ setCodes, force, cc, sc, ca, sa, setIcons, thumbs });
      setLastJobId(res.jobId);
      toast.success(`Image ingest enqueued (${res.jobId})`);
    }
    catch (e: any) {
      toast.error(e?.message || `${e}`);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <DevToolSection
      title="Ingest Card Images"
      description="Traverse /nfs/cardImages/{cc,sc,ca,sa} and set the FileMeta fields on Card records, matched by numeric filename (= card id): cc &rarr; mtgoImage, sc &rarr; scryfallImage, ca &rarr; mtgoArtwork, sa &rarr; scryfallArtwork. Then set icons (Scryfall /sets &rarr; sets.image), then thumbnails last (tc/ta &rarr; imageThumb/artworkThumb, Scryfall preferred, MTGO fallback); uncheck the dirs for an icons/thumbnails-only run. Watch server logs for per-set progress."
      buttonText="Enqueue Ingest"
      onRun={run}
      loading={loading}
    >
      <div className={devFieldStack}>
        <div>
          <label className={devLabel}>
            Set codes (comma-separated; blank = ALL sets)
          </label>
          <Input
            value={setCodes}
            onChange={(v) => setSetCodes(v ?? '')}
            onEnter={() => run()}
            placeholder="10E, 2X2, SOS"
            autoComplete="off"
          />
        </div>
        <div className={devCheckRow}>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={cc} onChange={(e) => setCc(e.target.checked)} />
            cc &rarr; mtgoImage
          </label>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={sc} onChange={(e) => setSc(e.target.checked)} />
            sc &rarr; scryfallImage
          </label>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={ca} onChange={(e) => setCa(e.target.checked)} />
            ca &rarr; mtgoArtwork
          </label>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={sa} onChange={(e) => setSa(e.target.checked)} />
            sa &rarr; scryfallArtwork
          </label>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={setIcons} onChange={(e) => setSetIcons(e.target.checked)} />
            Set icons (Scryfall &rarr; sets.image)
          </label>
          <label className={devCheckLabel}>
            <input type="checkbox" checked={thumbs} onChange={(e) => setThumbs(e.target.checked)} />
            Thumbnails (tc/ta &rarr; imageThumb/artworkThumb)
          </label>
        </div>
        <label className={devCheckLabel}>
          <input type="checkbox" checked={force} onChange={(e) => setForce(e.target.checked)} />
          Force overwrite (re-set fields that already exist)
        </label>
      </div>
      {lastJobId && (
        <div className={devHint}>
          Last enqueued jobId: <code>{lastJobId}</code>
        </div>
      )}
    </DevToolSection>
  );
};
